import { render, staticRenderFns } from "./Catalogo2023.vue?vue&type=template&id=bca79684&"
import script from "./Catalogo2023.vue?vue&type=script&lang=js&"
export * from "./Catalogo2023.vue?vue&type=script&lang=js&"
import style0 from "./Catalogo2023.vue?vue&type=style&index=0&id=bca79684&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports